import React from "react"
import { connect } from "react-redux"
import { navigate } from "gatsby"
import API, { graphqlOperation } from "@aws-amplify/api"
import { Title } from "@thedgbrt/logology-ui-components"
import {
  previousStep,
  updateAnswer,
  saveStepAndGoNext,
} from "../../state/actions/questionnaire"
import { useQuestionData } from "./data/useQuestionData"
import AnswerButtons from "./AnswerButtons"

// const enhanceAnswers = (answers, sectorName) =>
//   answers.map(answer => ({
//     ...answer,
//     title: answer.title.replace("__sector__", sectorName),
//   }))

const Question = ({
  basepath,
  id,
  saveStepAndGoNext,
  selectedAnswerId,
  updateAnswer,
  step,
  type,
}) => {
  // get question data from local json file
  const { answers, display, title } = useQuestionData()[id]
  // enhance answer text with known data about the user
  // const sectorName = useSectorData()[sectorId].title
  // const answersEnhanced = enhanceAnswers(answers, sectorName)

  const handleSelect = answerId => {
    updateAnswer(id, answerId)
    // this delay helps the user understand that his selection worked
    // by showing the answer in a selected state for 250ms
    // before going to the next screen
    setTimeout(() => {
      navigate(`${basepath}${step + 1}`)
      if (type === "private") saveStepAndGoNext(API, graphqlOperation)
    }, 250)
  }

  return (
    <>
      <Title level={3}>{title}</Title>
      <AnswerButtons
        answers={answers}
        oneColumn={display === "rows"}
        handleSelect={handleSelect}
        selectedId={selectedAnswerId}
      />
    </>
  )
}

export default connect(
  ({ questionnaire }, ownProps) => ({
    selectedAnswerId: questionnaire.answers[`_${ownProps.id}`],
  }),
  { updateAnswer, saveStepAndGoNext, previousStep }
)(Question)
